import styled from 'styled-components';

export const InputItem = styled.div`
    .searchtStyle {
        border-width: ${(props) =>
            props.bwidth ? props.bwidth : '0 !important'};
        width: ${(props) =>
            props.scrWidth ? props.scrWidth : '100% !important'};
        outline: ${(props) => (props.outline ? props.outline : '0 !important')};
        padding: ${(props) => (props.pd ? props.pd : '6px !important')};
        background: ${(props) =>
            props.background
                ? props.background
                : '#FFFFFF 0% 0% no-repeat padding-box'};
        border: ${(props) => (props.border ? props.border : '0px !important')};
        border-radius: ${(props) =>
            props.borderRadius ? props.borderRadius : '0px !important'};
        opacity: ${(props) =>
            props.opacity ? props.opacity : '0px !important'};
    }
    .inputSearch .MuiInput-underline:before,
    .MuiInput-underline:after,
    .MuiInput-underline:hover:not(.Mui-disabled):before {
        border-bottom: 0px solid rgba(0, 0, 0, 0.42);
    }
    .MuiAutocomplete-input {
        font-size: 14px;
    }

    .inputSearch div .MuiTextField-root {
        width: 100%;
    }
`;
